import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "inviteReviewView__content" }
const _hoisted_2 = { class: "inviteReviewView__controls" }
const _hoisted_3 = { class: "fl-row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("确定要 "),
  /*#__PURE__*/_createElementVNode("b", null, "允许"),
  /*#__PURE__*/_createTextVNode(" 该人加入企业?")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "确认", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("确定要 "),
  /*#__PURE__*/_createElementVNode("b", null, "拒绝"),
  /*#__PURE__*/_createTextVNode(" 该人加入企业?")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-error"
}, "拒绝", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_user_input = _resolveComponent("app-user-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_app_enterprise_input = _resolveComponent("app-enterprise-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer inviteReviewView" }, {
    title: _withCtx(() => [
      _createVNode(_component_router_link, {
        class: "link-goback",
        to: {name: 'main.staff.list'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_icon, { type: "arrow-left" })
        ]),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(" 员工加入审核 ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          class: "fl-clean filterForm inviteReviewView__filterForm",
          model: _ctx.filterParams,
          layout: 'inline'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "员工" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_user_input, {
                  value: _ctx.filterParams.userRelId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParams.userRelId) = $event)),
                  style: {"width":"200px"},
                  "get-data": _ctx.getUserList
                }, null, 8, ["value", "get-data"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "链接名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.filterParams.invitationName,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.invitationName) = $event)),
                  "allow-clear": "",
                  placeholder: "链接名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "公司" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_enterprise_input, {
                  value: _ctx.filterParams.enterpriseId,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.enterpriseId) = $event)),
                  style: {"width":"200px"},
                  "with-default-all": "",
                  "disable-in-open": ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  ghost: "",
                  onClick: _ctx.onRefreshTable
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.current,
          "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.current) = $event)),
          animated: false
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_a_tab_pane, { key: 1 }, {
              tab: _withCtx(() => [
                _createTextVNode(" 待审核 "),
                _createVNode(_component_a_badge, { count: _ctx.badgeTotal }, null, 8, ["count"])
              ]),
              _: 1
            })),
            (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: 2,
              tab: "已通过"
            })),
            (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: 3,
              tab: "已拒绝"
            }))
          ]),
          _: 1
        }, 8, ["activeKey"]),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            type: "primary",
            disabled: !_ctx.tableSelectedRows.length,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.mutiSubmit('SUCCESS')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量确认")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, {
            type: "primary",
            disabled: !_ctx.tableSelectedRows.length,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mutiSubmit('FAIL')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量拒绝")
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 512), [
          [_vShow, _ctx.current === 1]
        ]),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "id",
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData,
          alert: _ctx.tableOptions.alert,
          "row-selection": _ctx.tableOptions.rowSelection,
          "show-pagination": true
        }, {
          action: _withCtx(({ record }) => [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_a_popconfirm, {
                placement: "top",
                onConfirm: ($event: any) => (_ctx.submitResult([record.id], 'SUCCESS'))
              }, {
                title: _withCtx(() => [
                  _hoisted_4
                ]),
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onConfirm"]),
              _hoisted_6,
              _createVNode(_component_a_popconfirm, {
                placement: "top",
                onConfirm: ($event: any) => (_ctx.submitResult([record.id], 'FAIL'))
              }, {
                title: _withCtx(() => [
                  _hoisted_7
                ]),
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ])
          ]),
          _: 1
        }, 8, ["columns", "data", "alert", "row-selection"])
      ])
    ]),
    _: 1
  }))
}